export default __webpack_public_path__ + "static/media/D4.9cabd170.mp3";